/**
 * Client-side CSV export of already-fetched rows — no server-side export endpoint exists
 * anywhere in this system (see `AccountingCsv.Build`/BillingService for the one backend CSV
 * export that does exist, but it's legacy-invoice-specific and unwired to any frontend), so
 * this is a real export of what's actually on screen rather than a fabricated "export all"
 * that hits nothing real. Lifted from `routes/(admin)/analytics/page.tsx`'s original
 * `downloadCsv` (same shape) so Products/Orders can reuse it instead of re-inventing it.
 *
 * Because list pages here are cursor-paginated (20/page), this only exports the current page
 * of the current filters — callers should label their button accordingly (e.g. "Export page"),
 * not "Export all", to stay honest about what happens.
 */
export function downloadCsv<T extends object>(filename: string, rows: T[]) {
  if (rows.length === 0) return
  const headers = Object.keys(rows[0]) as (keyof T)[]
  const csv = [
    headers.join(','),
    ...rows.map((r) => headers.map((h) => JSON.stringify(r[h] ?? '')).join(',')),
  ].join('\n')
  const blob = new Blob([csv], { type: 'text/csv' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}
